import { render } from "./SelectSingleButton.vue?vue&type=template&id=5a007821"
import script from "./SelectSingleButton.vue?vue&type=script&lang=ts"
export * from "./SelectSingleButton.vue?vue&type=script&lang=ts"
script.render = render

export default script